<ew-mat-dialog-custom>
  <ew-mat-stepper-custom
    [sendIn]="'last'"
    [validations]="validations"
    [textForSendButton]="'shared:send'"
    (send)="convertCurrency()">
    <!-- Select sender account -->
    <ew-mat-stepper-custom-step
      [classContainer]="'text-center'"
      [title]="'createConvertFunds:selectSenderTitle'"
      [subtitle]="'createConvertFunds:selectSenderSubtitle'">
      <div
        class="grid xs:grid-cols-1 grid-cols-2 gap-4 max-w-xl m-auto text-left mt-8">
        <mat-progress-spinner
          class="translate-y-[75%] left-[100%]"
          [diameter]="24"
          [mode]="'indeterminate'"
          *ngIf="loadingAccounts"></mat-progress-spinner>
        <ew-currency-money
          [item]="item"
          [dollarConversion]="false"
          [showIncomeBalance]="false"
          [hideNullBalance]="true"
          [selected]="item === sender"
          *ngFor="let item of senders"
          (click)="resetReceiverValues(); sender = item"></ew-currency-money>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- Select receiver account -->
    <ew-mat-stepper-custom-step
      [classContainer]="'text-center'"
      [title]="'createConvertFunds:selectReceiverTitle'"
      [subtitle]="'createConvertFunds:selectReceiverSubtitle'">
      <div
        class="grid xs:grid-cols-1 grid-cols-2 gap-4 p-4 max-w-xl m-auto text-left mt-8">
        <ew-currency-money
          [item]="item"
          [showIncomeBalance]="false"
          [selected]="item === receiver"
          [dollarConversion]="false"
          *ngFor="let item of filteredReceivers"
          (click)="resetReceiverValues(); receiver = item"></ew-currency-money>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- Confirmation -->
    <ew-mat-stepper-custom-step
      [classContainer]="'text-center grid max-w-xl m-auto'"
      [title]="'createConvertFunds:confirmationTitle'"
      [subtitle]="'createConvertFunds:confirmationSubtitle'">
      <div class="text-left mt-8">
        <div>
          <span class="text-sm mb-1 block">{{
            'createConvertFunds:senderAccountDescription' | translate
          }}</span>
          <ew-table-card-item
            class="border border-gray-300 p-4 flex"
            [img]="
              'https://flagcdn.com/' +
              (sender?.currencyIso | currencyCountry) +
              '.svg'
            "
            [title]="sender?.currencyIso"
            [subtitle]="
              ('createConvertFunds:confirmationCurrentBalance' | translate) +
                (sender?.balance | currency : sender?.currencyIso : 'symbol') ||
              ''
            ">
          </ew-table-card-item>
        </div>
        <div class="flex-col my-5">
          <div class="flex-row">
            <p class="text-sm">
              {{ 'createConvertFunds:amountToSend' | translate }}
            </p>
          </div>
          <div class="flex">
            <span class="flex font-bold text-5xl mr-4 mt-1"
              >{{ getCurrencySymbol(sender?.currencyIso) }}
            </span>
            <input
              ewPreventScroll
              class="flex font-bold text-5xl"
              mask="separator.2"
              thousandSeparator=","
              decimalMarker="."
              [formControl]="senderAmount"
              placeholder="1.00"
              step=".01"
              id="sender-amount" />
          </div>
          <div class="flex-row">
            <span class="text-sm text-gray-500">{{
              ('createConvertFunds:confirmationCurrentBalance' | translate) +
                (sender?.balance | currency : sender?.currencyIso : 'symbol')
            }}</span>
          </div>
          <div class="flex items-center gap-2 text-grey-500 text-sm">
            <mat-error *ngIf="insufficientFunds()">
              <strong class="text-xs relative">{{
                'createConvertFunds:insuficientFunds' | translate
              }}</strong>
            </mat-error>
            <span class="relative" *ngIf="!insufficientFunds()">
              FX Rate: {{ fxRates.baseCurrency }} =
              {{ fxRates.destCurrency }} ({{
                'createConvertFunds:confirmationBetweenAccounts' | translate
              }})
            </span>
            <mat-progress-spinner
              [diameter]="24"
              [mode]="'indeterminate'"
              *ngIf="loadingRateQuote"></mat-progress-spinner>
          </div>
        </div>
        <div>
          <span class="text-sm mb-1 block">{{
            'createConvertFunds:receiverAccountDescription' | translate
          }}</span>
          <ew-table-card-item
            class="border border-gray-300 p-4 flex"
            [img]="
              'https://flagcdn.com/' +
              (receiver?.currencyIso | currencyCountry) +
              '.svg'
            "
            [title]="receiver?.currencyIso"
            [subtitle]="
              ('createConvertFunds:confirmationCurrentBalance' | translate) +
                (receiver?.balance
                  | currency : receiver?.currencyIso : 'symbol') || ''
            ">
          </ew-table-card-item>
          <mat-progress-spinner
            class="translate-y-[75%] left-[50%]"
            [diameter]="30"
            [mode]="'indeterminate'"
            *ngIf="loadingRateQuote"></mat-progress-spinner>
          <span
            class="mt-4 block text-lg"
            *ngIf="!loadingRateQuote && receiverAmount.value !== 0"
            >{{
              'createConvertFunds:confirmationAfterBalance' | translate
            }}</span
          >
          <p
            class="block text-5xl mt-2 font-bold"
            *ngIf="!loadingRateQuote && receiverAmount.value !== 0">
            {{
              receiverAmount.value | currency : receiver?.currencyIso : 'symbol'
            }}
          </p>
        </div>
        <div class="my-4">
          <span class="text-sm mb-1 block">{{
            'createConvertFunds:referenceDescription' | translate
          }}</span>
          <input
            class="block w-full p-2 border"
            [class.border-red-500]="reference.errors && reference.touched"
            matInput
            required
            [formControl]="reference"
            name="reference" />
        </div>
        <mat-error *ngIf="reference.errors">
          <span *ngIf="reference.touched && reference.errors['pattern']">
            <strong class="text-xs relative mb-4">{{
              'createConvertFunds:referenceValidationError' | translate
            }}</strong>
          </span>
          <span *ngIf="reference.touched && reference.errors['required']">
            <strong class="text-xs relative mb-4">{{
              'createConvertFunds:referenceRequired' | translate
            }}</strong>
          </span>
        </mat-error>
        <mat-checkbox [formControl]="confirmation">
          <span>
            {{ 'createConvertFunds:checkboxConfirmation' | translate }}
          </span>
        </mat-checkbox>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
